import React from 'react';
import styled from 'styled-components';
import { Typography } from '~/components/shared/Typography/Typography';
import useTranslate from '~/hooks/useTranslate';
import { InvoiceSection, InvoiceTabValue } from '~/Interfaces';
import { theme } from '~/styles/themes';

const SubMenuContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: end;
  height: 5em;
  background-color: white;
  box-shadow: 0 1.25em 1.25em -1.25em #00000020;
  margin-bottom: 1.4em;
  @media (orientation: landscape) {
    background-color: transparent;
    box-shadow: none;
    margin-bottom: 1.4em;
  }
`;

const TextHolder = styled.div`
  padding-bottom: 1rem;
  flex: 1;
  margin: 0em 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  text-align: center;
`;

const Underline = styled.div`
  width: 50%;
  border: 2px solid ${theme.colors.secondary};
  margin-top: 0.5em;
`;

const Placeholder = styled.div`
  width: 50%;
  height: 2px;
  margin-top: 0.5em;
`;

interface Props {
  onItem: (item: InvoiceTabValue) => void;
  selectedItem: string;
}

const ListOfInvoicesSubMenu: React.FC<Props> = ({ selectedItem, onItem }) => {
  const t = useTranslate();
  const sections: InvoiceSection[] = [
    {
      label: t('Invoices.Open'),
      key: InvoiceTabValue.OPEN,
    },
    {
      label: t('Invoices.Paid'),
      key: InvoiceTabValue.PAID,
    },
    {
      label: t('Invoices.Archived'),
      key: InvoiceTabValue.ARCHIVED,
    },
  ];
  return (
    <SubMenuContainer>
      {sections.map((section) => (
        <TextHolder key={section.key} onClick={() => onItem(section.key)}>
          <Typography
            color={
              selectedItem === section.key
                ? theme.colors.secondary
                : theme.colors.newSecondaryGray
            }
            fontWeight={selectedItem === section.key ? 600 : 400}
            fontSize={0.8}
          >
            {section.label}
          </Typography>
          {selectedItem === section.key ? <Underline /> : <Placeholder />}
        </TextHolder>
      ))}
    </SubMenuContainer>
  );
};

export default ListOfInvoicesSubMenu;
